<template>
  <div class="jump-page"></div>
</template>
<script>
import { getPublicize } from '@/api/base';
import { getAppStatus } from '@/utils/app';

export default {
  name: 'SpdbJump',
  data() {
    return {
      userId: getAppStatus().cuserId,
    };
  },
  computed: {
    userIds() {
      return getAppStatus().cuserId;
    },
    title() {
      return document.referrer;
    },
  },
  mounted() {
    document.title = '';
    let status = sessionStorage.getItem('add');
    this.getPublicize();
  },
  watch: {
    $route: {
      handler(val, from) {
        console.log(from);
      },
      immediate: true,
    },
  },
  methods: {
    async getPublicize() {
      let res;
      let data = { paramV: 'dddd' };
      const { host } = window.location;
      const { query } = this.$route;
      try {
        res = await getPublicize(query);
      } catch (e) {
        console.log(e);
        window.location.replace(`//${host}/bank/404`);
      }
      if (res.code === 1) {
        this.linkUrl = res?.results?.linkUrl;
        this.channel = res?.results?.channel;
        sessionStorage.setItem('shortData', JSON.stringify(res?.results || {}));
        if (this.linkUrl) {
          const { transferType } = res?.results || {};
          let { jumpLevel } = res?.results || 2;
          if (!transferType) {
            this.$router.push({
              path: '/leaflet/poster',
            });
          }
          if (transferType) {
            let timestamp = new Date().getTime() / 1000;
            timestamp = Math.floor(timestamp);
            let fromPath = this.$route.path;
            let { linkUrl } = res?.results || {};
            if (jumpLevel > 1 && linkUrl) {
              this.$router.push({
                path: `/leaflet/jump${jumpLevel - 1}`,
                query: {
                  timestamp,
                  fromPath,
                },
              });
            }
            if ((!jumpLevel || jumpLevel === 1) && linkUrl) {
              window.location.replace(linkUrl);
            }
            if (!linkUrl) {
              window.location.replace(`//${host}/bank/404`);
            }
          }
          // if (transferType) this.$router.push('/leaflet/poster');
        } else {
          window.location.replace(`//${host}/bank/404`);
        }
      } else {
        window.location.replace(`//${host}/bank/404`);
      }
    },
  },
};
</script>
<style scoped>
  .jump-page {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
  }
</style>
